<style scoped>
.visa-frame {
  margin: 32px
}
@media only screen and (max-width: 480px) {
  .visa-frame {
    margin: 32px 0px 
  }
}

</style>
<style>
.pay-url {
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid #999; background-color: #eee; padding: 4px; margin: 8px; line-height: 1em;
}
</style>

<template>
  <div> 
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 40%; max-width: 200px">
        <img src="/static/credit-card2.svg">
      </div>
    </div>

    <div v-if="!paymentDone">
      <div style="padding: 16px"><h2>Ask a friend to pay for you</h2></div>

      <md-card v-if="$route.params.cart == 'VISA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Help with your visa application file{{price}}&euro; TTC</div>
            <div class="md-subhead">Help for your visa application file.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="$route.params.cart == 'CRRV'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Appeals Board on Visa Refusals {{price}}&euro; TTC</div>
            <div class="md-subhead">Appeal to the Appeals Board on Visa Refusals.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="$route.params.cart == 'TA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Administrative Court of Nantes{{price}}&euro; TTC</div>
            <div class="md-subhead">appeal to the Administrative Court of Nantes</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="$route.params.cart == 'PREMIUM'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Pack Premium {{price}}&euro; TTC</div>
            <div class="md-subhead">You are assisted and defended by a lawyer.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/lawyer.svg">
          </md-card-media>
        </md-card-header>
      </md-card>
      



      <div class="light-frame visa-frame" >
        

        <div style="margin-top: 16px">
        Your friend needs to have a payment card like MasterCard, VISA, AMEX
        </div>
        <div class="centered-child">
           <div>
            <img src="/static/visa.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/mastercard.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/american-express.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/locked.svg" style="height: 24px; margin: 0px 4px">
          </div>
        </div>

        <div class="centered-child">
         Copy the link below and send it to your friend :
        </div>

        <div class="centered-child">
          <span class="pay-url">{{payURL}}</span>
          <div style="display: flex; flex-wrap: wrap; justify-content: center">
            <md-button @click="onCopy()">Copy</md-button>
            <md-button @click="onEmail()">Send by email</md-button>
          </div>
        </div>

        <div class="centered-child" style="margin-top: 32px">
          Once the payment made by your friend, You will receive an email to continue to fill your file and get your appeal.
        </div>

        <div class="centered-child" style="margin-top: 24px">
          <md-button class="md-raised md-primary large-button" 
          @click="onClickPay()"
          :disabled="loading">
            <span>Continue</span> 
          </md-button>
        </div>

      </div>
      
    </div>
    <div v-else>
        <h2>We are wainting for your friend payment</h2>
        <p>A summary email has just been sent to you<p>

        <div class="centered-child" style="margin-top: 48px">
          <md-button class="md-raised md-primary large-button"
           @click="onClickContinue()"
           >Continue</md-button>
        </div>


    </div>


  </div>
</template>

<script>

import ServiceAccess from '../service/ServiceAccess'

export default {
  data: function () {
    return {
      payURL: '...',
      loading: false,
      paymentDone: false
    }
  },



  computed: {
    price: function () {
      let price = 0
      if (this.$route.params.cart === 'PREMIUM') {
        price = 999
      } else if (this.$route.params.cart === 'VISA') {
        price = 120
        // no discount for VISA
        return
      } else if (this.$route.params.cart === 'CRRV') {
        price = 299
      } else if (this.$route.params.cart === 'TA') {
        price = 299
      }
      return price
    }
  },


  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)


    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.checkoutFriendURL(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [values, url] = responses
      this.values = values
      this.payURL = url
    })
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      if (this.paymentDone) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/')
      } else {
        this.$router.back()
      }
    },



    onClickPay: function () {   

      ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-pay', {kind: 'stripe-friend'})
      this.loading = true

      ServiceAccess.instance.checkoutFriend(this.$route.params.sessionId, this.$route.params.cart).then(resp => {
        this.paymentDone = true
        this.loading = false
      })


    },

    onCopy: function () {
      let selection = window.getSelection()
      selection.removeAllRanges()
      let payUrlSpan = this.$el.querySelector('.pay-url').firstChild
      let range = document.createRange()
      range.selectNode(payUrlSpan)
      selection.addRange(range)

      try {  
        document.execCommand('copy')
      } catch (err) {  
        console.error('Unable to copy', err)
      }
    },
    onEmail: function () {
      window.open('mailto:?subject=Aide pour dossier de visa pour la France&body=Bonjour,%0A%0AAfin de compléter ma procédure de visa pour la France, il faut effectuer un paiement en utilisant le lien sécurisé suivant :%0A' + this.payURL)
    },

    onClickContinue: function () {
      this.$router.replace('/f/' + this.$route.params.sessionId + '/')
    }





  }


}
</script>


// WEBPACK FOOTER //
// CheckoutStripeFriend.vue?9a32dc24